import { useState } from "react";
import { Menu, X } from "lucide-react";
import { AnchorLink } from "@/components/AnchorLink";
import { scrollToId } from "@/lib/scroll";
import { useLocation, useNavigate } from "react-router-dom";

const NAV = [
  { label: "Meet Peanut Valet", to: "#meet", testId: "nav-link-meet" },
  { label: "The Experience", to: "#experience", testId: "nav-link-experience" },
  { label: "Our Vision", to: "#vision", testId: "nav-link-vision" },
  { label: "Partners", to: "#partner", testId: "nav-link-partners" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const goSignup = () => {
    setOpen(false);
    if (pathname === "/") scrollToId("#signup");
    else navigate("/#signup");
  };

  return (
    <header
      data-testid="header-nav"
      className="fixed inset-x-0 top-0 z-50 border-b border-[#EADCC6] bg-[#F7F1E6]/90 backdrop-blur-md"
    >
      <div className="mx-auto flex h-20 max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-8">
        <AnchorLink to="#meet" testId="brand-logo" className="flex shrink-0 items-center" onDone={() => setOpen(false)}>
          <img
            src="/assets/peanut-valet-logo.webp"
            alt="Peanut Valet logo"
            className="h-12 w-auto sm:h-14"
            width="720"
            height="476"
          />
        </AnchorLink>

        <nav className="hidden items-center gap-8 md:flex" aria-label="Main navigation">
          {NAV.map((item) => (
            <AnchorLink
              key={item.to}
              to={item.to}
              testId={item.testId}
              className="text-[15px] font-bold text-[#074345] transition-colors duration-200 hover:text-[#F3802A]"
            >
              {item.label}
            </AnchorLink>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <button
            type="button"
            data-testid="nav-cta-keep-me-updated"
            onClick={goSignup}
            className="hidden rounded-full bg-[#F3802A] px-6 py-3 text-[15px] font-extrabold text-[#043436] transition-[transform,filter] duration-200 hover:scale-[1.04] hover:brightness-95 active:scale-[0.97] sm:inline-flex"
          >
            Keep Me Updated
          </button>
          <button
            type="button"
            data-testid="mobile-menu-button"
            aria-expanded={open}
            aria-label={open ? "Close menu" : "Open menu"}
            onClick={() => setOpen(!open)}
            className="inline-flex h-11 w-11 items-center justify-center rounded-full text-[#074345] transition-colors hover:bg-[#EADCC6] md:hidden"
          >
            {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="border-t border-[#EADCC6] bg-[#F7F1E6] px-4 pb-6 pt-2 md:hidden">
          <nav className="flex flex-col" aria-label="Mobile navigation">
            {NAV.map((item) => (
              <AnchorLink
                key={item.to}
                to={item.to}
                testId={`mobile-${item.testId}`}
                onDone={() => setOpen(false)}
                className="border-b border-[#EADCC6] py-4 text-left text-lg font-bold text-[#074345]"
              >
                {item.label}
              </AnchorLink>
            ))}
          </nav>
          <button
            type="button"
            data-testid="mobile-nav-cta-keep-me-updated"
            onClick={goSignup}
            className="mt-5 w-full rounded-full bg-[#F3802A] px-6 py-4 text-base font-extrabold text-[#043436] transition-[transform,filter] duration-200 hover:brightness-95 active:scale-[0.98]"
          >
            Keep Me Updated
          </button>
        </div>
      )}
    </header>
  );
};
